let code = 'app';
let codeAPI = 'genericapplication';

let codeMap = 'map';
let codeOs = 'os';

export const apiConstants = {
    code: `${code}`,
    codeMap: `${codeMap}`,
    codeOs: `${codeOs}`,
    codeAPI: `${codeAPI}`,
};